(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuance-media-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(scroller) {
      if (scroller.dataset.nmsReady === 'true') return;
      scroller.dataset.nmsReady = 'true';

      // Drag to scroll with the mouse (touch screens already swipe natively)
      var down = false;
      var startX = 0;
      var startLeft = 0;
      var moved = 0;
      var pointerId = null;

      // Belt and braces with the CSS above: no native drag of an image or a link
      scroller.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });

      scroller.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'touch' || event.button !== 0) return;
        down = true;
        moved = 0;
        startX = event.clientX;
        startLeft = scroller.scrollLeft;
        pointerId = event.pointerId;
        // Capture keeps the drag alive when the cursor wanders off the strip
        try {
          scroller.setPointerCapture(pointerId);
        } catch (e) {}
        scroller.setAttribute('data-nms-dragging', '');
        event.preventDefault();
      });

      scroller.addEventListener('pointermove', function (event) {
        if (!down) return;
        event.preventDefault();
        var delta = event.clientX - startX;
        if (Math.abs(delta) > moved) moved = Math.abs(delta);
        scroller.scrollLeft = startLeft - delta;
      });

      function release() {
        if (!down) return;
        down = false;
        if (pointerId !== null) {
          try {
            scroller.releasePointerCapture(pointerId);
          } catch (e) {}
          pointerId = null;
        }
        scroller.removeAttribute('data-nms-dragging');
      }

      scroller.addEventListener('pointerup', release);
      scroller.addEventListener('pointercancel', release);
      window.addEventListener('blur', release);

      // A drag must not follow the link underneath
      scroller.addEventListener(
        'click',
        function (event) {
          if (moved > 6) {
            event.preventDefault();
            event.stopPropagation();
            moved = 0;
          }
        },
        true
      );

      // Nothing inside a frame may carry its own size: strip the attributes the platform
      // writes onto the media, whatever the media turns out to be.
      scroller.querySelectorAll('.nms__frame *').forEach(function (node) {
        node.removeAttribute('width');
        node.removeAttribute('height');
      });

      // Only play the videos that are on screen, and never with sound
      var videos = scroller.querySelectorAll('video');
      if (!videos.length) return;

      videos.forEach(function (video) {
        video.muted = true;
        video.defaultMuted = true;
        video.volume = 0;
        video.setAttribute('muted', '');
        video.removeAttribute('controls');
        video.setAttribute('playsinline', '');
        // If anything ever tries to unmute it, put it straight back
        video.addEventListener('volumechange', function () {
          if (!video.muted || video.volume !== 0) {
            video.muted = true;
            video.volume = 0;
          }
        });
      });

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var video = entry.target;
              if (entry.isIntersecting) {
                var playing = video.play();
                if (playing && playing.catch) playing.catch(function () {});
              } else {
                video.pause();
              }
            });
          },
          { root: scroller, threshold: 0.25 }
        );
        videos.forEach(function (video) {
          observer.observe(video);
        });
      } else {
        videos.forEach(function (video) {
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        });
      }
    }

    function init() {
      document.querySelectorAll('[data-nms-scroller]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuance-product-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nuance-grid')) {
    customElements.define(
      'nuance-grid',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.prev = this.querySelector('[data-prev]');
          this.next = this.querySelector('[data-next]');
          this.viewport = this.querySelector('.ngrid__viewport');
          if (!this.track) return;

          this.place = () => {
            if (!this.viewport) return;
            const media = this.track.querySelector('.ncard__media') || this.track.querySelector('img');
            if (!media) return;
            const mediaBox = media.getBoundingClientRect();
            const box = this.viewport.getBoundingClientRect();
            if (!mediaBox.height || !box.height) return;
            this.viewport.style.setProperty('--ngrid-arrow-top', Math.round(mediaBox.top - box.top + mediaBox.height / 2) + 'px');
          };

          this.onResize = () => {
            requestAnimationFrame(this.place);
          };

          window.addEventListener('resize', this.onResize);
          window.addEventListener('load', this.onResize);
          requestAnimationFrame(this.place);

          if (!this.prev || !this.next) return;

          // Width of one card, gap included
          this.cardWidth = () => {
            const item = this.track.querySelector('.ngrid__item');
            if (!item) return 0;
            const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
            return item.offsetWidth + gap;
          };

          // Moves one card from one end to the other with no visible jump,
          // so the carousel loops in both directions
          this.rotate = (toStart, width) => {
            const items = this.track.children;
            if (items.length < 2) return;
            const before = this.track.scrollLeft;
            this.track.style.scrollBehavior = 'auto';
            if (toStart) {
              this.track.insertBefore(items[items.length - 1], items[0]);
              this.track.scrollLeft = before + width;
            } else {
              this.track.appendChild(items[0]);
              this.track.scrollLeft = Math.max(0, before - width);
            }
            void this.track.offsetWidth;
            this.track.style.scrollBehavior = '';
          };

          // One card per click. Left arrow slides the cards to the right.
          this.go = (direction) => {
            const width = this.cardWidth();
            if (!width) return;
            const max = this.track.scrollWidth - this.track.clientWidth;
            if (direction < 0 && this.track.scrollLeft <= 1) {
              this.rotate(true, width);
            } else if (direction > 0 && this.track.scrollLeft >= max - 1) {
              this.rotate(false, width);
            }
            this.track.scrollBy({ left: direction * width, behavior: 'smooth' });
          };

          this.prev.addEventListener('click', () => this.go(-1));
          this.next.addEventListener('click', () => this.go(1));
        }

        disconnectedCallback() {
          if (this.onResize) {
            window.removeEventListener('resize', this.onResize);
            window.removeEventListener('load', this.onResize);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuance-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nuance-reviews')) {
    const STAR_PATH =
      'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z';
    const WORDS = ['', 'Poor', 'Fair', 'Good', 'Very good', 'Excellent'];
    const FOCUSABLE =
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])
    );

    /* One star, drawn as a single SVG: the square, the grey remainder of a partly earned
       star and the glyph all live in the same 100-unit coordinate system, so nothing can
       shift relative to anything else when the browser rounds the box to physical pixels.
       `fill` is 0..1: 1 paints the square green, 0 leaves it the pale grey, and anything
       between splits it at exactly that fraction, so 4.81 reads as 4.81. */
    function star(fill) {
      const solid = fill >= 0.999;
      const empty = fill <= 0.001;
      let out = '<svg class="nrev-star" viewBox="0 0 100 100" aria-hidden="true" focusable="false">';
      out += '<rect class="nrev-star__box' + (empty ? ' nrev-star__box--empty' : '') + '" width="100" height="100"/>';
      if (!solid && !empty) {
        const cut = (fill * 100).toFixed(3);
        out += '<rect class="nrev-star__box nrev-star__box--empty" x="' + cut + '" width="' + (100 - cut).toFixed(3) + '" height="100"/>';
      }
      out += '<path class="nrev-star__ink" d="' + STAR_PATH + '" transform="translate(20 18.75) scale(2.5)"/>';
      return out + '</svg>';
    }

    function starRow(value) {
      let out = '';
      for (let i = 0; i < 5; i += 1) out += star(Math.min(1, Math.max(0, value - i)));
      return out;
    }

    /* Survives the page reload an email-mode submission costs. See the submit handler
       in bindForm and restoreAfterPost. */
    const POST_KEY = 'nuance-reviews:posted';

    customElements.define(
      'nuance-reviews',
      class extends HTMLElement {
        connectedCallback() {
          this.all = this.readData();

          const scope = this.dataset.scope || '';
          /* Store-wide keeps everything; per-product keeps that product's reviews. The
             only difference between the two modes, by design. */
          this.reviews = scope ? this.all.filter((r) => r.product === scope) : this.all;

          this.excerpt = parseInt(this.dataset.excerpt, 10) || 150;
          this.mode = this.dataset.mode === 'endpoint' ? 'endpoint' : 'email';
          this.endpoint = (this.dataset.endpoint || '').trim();

          this.state = { rating: null, photosOnly: false, sort: 'recent', shown: 0, draftRating: 0 };

          this.grid = this.querySelector('[data-nrev-grid]');
          this.modal = this.querySelector('[data-nrev-modal]');
          this.lightbox = this.querySelector('[data-nrev-lightbox]');

          if (!this.reviews.length) {
            /* Nothing to average, nothing to filter, nothing to sort. The summary and the
               toolbar stay hidden and the empty state carries the section on its own. */
            this.querySelector('[data-nrev-empty]').hidden = false;
          } else {
            this.querySelector('[data-nrev-summary]').hidden = false;
            this.querySelector('[data-nrev-toolbar]').hidden = false;
            this.renderSummary();
          }

          this.bind();
          this.render();
          this.restoreAfterPost();
        }

        readData() {
          const tag = this.querySelector('[data-nrev-data]');
          if (!tag) return [];
          try {
            const parsed = JSON.parse(tag.textContent.trim() || '[]');
            return Array.isArray(parsed) ? parsed.filter((r) => r && r.rating) : [];
          } catch (e) {
            /* A malformed data file must not take the page down with it. */
            console.warn('[nuance-reviews] data is not valid JSON, showing no reviews', e);
            return [];
          }
        }

        perPage() {
          const key = window.matchMedia('(max-width: 749px)').matches ? 'perPageMobile' : 'perPageDesktop';
          return parseInt(this.dataset[key], 10) || 9;
        }

        /* ---------- reading the set ---------- */

        filtered() {
          let list = this.reviews.slice();
          if (this.state.rating) list = list.filter((r) => Number(r.rating) === this.state.rating);
          if (this.state.photosOnly) list = list.filter((r) => r.photo);

          const byDate = (a, b) => String(b.date || '').localeCompare(String(a.date || ''));
          if (this.state.sort === 'highest') list.sort((a, b) => b.rating - a.rating || byDate(a, b));
          else if (this.state.sort === 'lowest') list.sort((a, b) => a.rating - b.rating || byDate(a, b));
          else list.sort(byDate);

          return list;
        }

        average() {
          if (!this.reviews.length) return 0;
          const sum = this.reviews.reduce((t, r) => t + Number(r.rating), 0);
          return sum / this.reviews.length;
        }

        counts() {
          const c = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
          this.reviews.forEach((r) => {
            const n = Math.round(Number(r.rating));
            if (c[n] != null) c[n] += 1;
          });
          return c;
        }

        /* ---------- drawing ---------- */

        renderSummary() {
          const avg = this.average();
          this.querySelector('[data-nrev-average]').textContent = avg.toFixed(2);
          this.querySelector('[data-nrev-average-stars]').innerHTML = starRow(avg);

          const counts = this.counts();
          const total = this.reviews.length;
          let html = '';
          for (let n = 5; n >= 1; n -= 1) {
            /* Share of all reviews, not share of the biggest bucket. The bar and the
               figure beside it therefore say the same thing: a row reading 85% is drawn at
               85% of the track. Measuring against the biggest bucket instead would stretch
               the top row to the full width and make the number beside it look wrong. */
            const share = total ? (counts[n] / total) * 100 : 0;
            /* A rating held by a couple of reviews out of several hundred rounds to 0%,
               which reads as "nobody" next to a bar that is plainly there. */
            const label = counts[n] === 0 ? '0%' : share < 0.5 ? '<1%' : Math.round(share) + '%';
            html +=
              '<button type="button" class="nrev__bar" data-nrev-rating="' + n +
              '" aria-pressed="false" aria-label="' + n + ' star' + (n > 1 ? 's' : '') + ', ' +
              counts[n] + ' review' + (counts[n] === 1 ? '' : 's') + '">' +
              '<span class="nrev__bar-key">' + n + star(1) + '</span>' +
              '<span class="nrev__bar-track"><span class="nrev__bar-fill" style="width:' + share.toFixed(2) + '%"></span></span>' +
              '<span class="nrev__bar-count">' + label + '</span>' +
              '</button>';
          }
          this.querySelector('[data-nrev-bars]').innerHTML = html;
        }

        renderChips() {
          const withPhotos = this.reviews.filter((r) => r.photo).length;
          let html =
            '<button type="button" class="nrev__chip" data-nrev-chip="all" aria-pressed="' +
            (!this.state.rating && !this.state.photosOnly) + '">All reviews</button>' +
            '<button type="button" class="nrev__chip" data-nrev-chip="photos" aria-pressed="' +
            this.state.photosOnly + '">With photos (' + withPhotos + ')</button>';

          if (this.state.rating) {
            html +=
              '<button type="button" class="nrev__chip nrev__chip--clear" data-nrev-chip="clear-rating">' +
              this.state.rating + ' stars ×</button>';
          }
          this.querySelector('[data-nrev-chips]').innerHTML = html;
        }

        card(r) {
          const date = this.formatDate(r.date);
          const body = String(r.body || '');
          const long = body.length > this.excerpt;
          const short = long ? body.slice(0, this.excerpt).trimEnd() + '…' : body;

          let html = '<article class="nrev-card">';
          html +=
            '<div class="nrev-card__top"><div class="nrev-card__stars" role="img" aria-label="' +
            r.rating + ' out of 5">' + starRow(Number(r.rating)) + '</div>' +
            '<span class="nrev-card__date">' + esc(date) + '</span></div>';

          if (r.title) html += '<h3 class="nrev-card__title">' + esc(r.title) + '</h3>';

          html += '<p class="nrev-card__body" data-nrev-body>' + esc(short) + '</p>';
          if (long) {
            html +=
              '<button type="button" class="nrev-card__toggle" data-nrev-toggle data-short="' +
              esc(short) + '" data-full="' + esc(body) + '" data-open="false">Read more</button>';
          }

          if (r.photo) {
            html +=
              '<button type="button" class="nrev-card__photo" data-nrev-photo="' + esc(r.photo) +
              '" aria-label="Open photo full screen"><img src="' + esc(r.photo) + '" alt="" loading="lazy"></button>';
          }

          html += '<div class="nrev-card__foot"><span class="nrev-card__name">' + esc(r.name || '') + '</span>';
          if (r.verified) {
            html +=
              '<span class="nrev-card__verified"><span class="nrev-check" aria-hidden="true">' +
              '<svg viewBox="0 0 24 24" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span>Verified purchase</span>';
          }
          html += '</div></article>';
          return html;
        }

        formatDate(iso) {
          if (!iso) return '';
          const d = new Date(iso);
          if (Number.isNaN(d.getTime())) return String(iso);
          return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
        }

        render() {
          const list = this.filtered();
          const step = this.perPage();
          if (!this.state.shown) this.state.shown = step;
          const visible = list.slice(0, this.state.shown);

          this.grid.innerHTML = visible.map((r) => this.card(r)).join('');

          const empty = this.querySelector('[data-nrev-empty]');
          empty.hidden = list.length > 0;

          if (this.reviews.length) {
            this.renderChips();
            const bars = this.querySelector('[data-nrev-bars]');
            bars.dataset.dimmed = this.state.rating ? 'true' : 'false';
            bars.querySelectorAll('[data-nrev-rating]').forEach((b) => {
              b.setAttribute('aria-pressed', String(Number(b.dataset.nrevRating) === this.state.rating));
            });
          }

          const more = this.querySelector('[data-nrev-more]');
          more.hidden = visible.length >= list.length;
        }

        /* ---------- events ---------- */

        bind() {
          this.addEventListener('click', (e) => {
            const bar = e.target.closest('[data-nrev-rating]');
            if (bar) {
              const n = Number(bar.dataset.nrevRating);
              this.state.rating = this.state.rating === n ? null : n;
              this.state.shown = this.perPage();
              this.render();
              return;
            }

            const chip = e.target.closest('[data-nrev-chip]');
            if (chip) {
              const kind = chip.dataset.nrevChip;
              if (kind === 'all') {
                this.state.rating = null;
                this.state.photosOnly = false;
              } else if (kind === 'photos') {
                this.state.photosOnly = !this.state.photosOnly;
              } else if (kind === 'clear-rating') {
                this.state.rating = null;
              }
              this.state.shown = this.perPage();
              this.render();
              return;
            }

            const toggle = e.target.closest('[data-nrev-toggle]');
            if (toggle) {
              const open = toggle.dataset.open === 'true';
              const body = toggle.closest('.nrev-card').querySelector('[data-nrev-body]');
              body.textContent = open ? toggle.dataset.short : toggle.dataset.full;
              toggle.dataset.open = String(!open);
              toggle.textContent = open ? 'Read more' : 'Show less';
              return;
            }

            const photo = e.target.closest('[data-nrev-photo]');
            if (photo) {
              this.openLightbox(photo.dataset.nrevPhoto, photo);
              return;
            }

            if (e.target.closest('[data-nrev-more]')) {
              this.state.shown += this.perPage();
              this.render();
              return;
            }

            const opener = e.target.closest('[data-nrev-open]');
            if (opener) {
              this.openModal(opener);
              return;
            }

            if (e.target.closest('[data-nrev-close]') || e.target.closest('[data-nrev-close-overlay]')) {
              this.closeModal();
              return;
            }

            if (e.target.closest('[data-nrev-lightbox]')) {
              this.closeLightbox();
            }
          });

          this.querySelector('[data-nrev-sort]').addEventListener('change', (e) => {
            this.state.sort = e.target.value;
            this.state.shown = this.perPage();
            this.render();
          });

          this.onKey = (e) => {
            if (e.key === 'Escape') {
              if (!this.lightbox.hidden) this.closeLightbox();
              else if (!this.modal.hidden) this.closeModal();
            }
            if (e.key === 'Tab') this.trap(e);
          };
          document.addEventListener('keydown', this.onKey);

          this.buildRating();
          this.bindForm();
        }

        /* Keeps Tab inside whichever overlay is open. */
        trap(e) {
          const box = !this.lightbox.hidden ? this.lightbox : !this.modal.hidden ? this.modal : null;
          if (!box) return;
          const items = Array.from(box.querySelectorAll(FOCUSABLE)).filter((el) => el.offsetParent !== null);
          if (!items.length) return;
          const first = items[0];
          const last = items[items.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }

        openLightbox(src, opener) {
          this.lightboxOpener = opener;
          this.querySelector('[data-nrev-lightbox-img]').src = src;
          this.lightbox.hidden = false;
          document.documentElement.classList.add('nrev-open');
          this.querySelector('[data-nrev-lightbox-close]').focus();
        }

        closeLightbox() {
          this.lightbox.hidden = true;
          this.querySelector('[data-nrev-lightbox-img]').src = '';
          if (this.modal.hidden) document.documentElement.classList.remove('nrev-open');
          if (this.lightboxOpener) this.lightboxOpener.focus();
        }

        /* The opener is passed in rather than read from document.activeElement. Safari
           does not focus a button when it is clicked, so activeElement would be the body
           there and closing would drop focus to the top of the page. */
        openModal(opener) {
          this.modalOpener = opener || document.activeElement;
          this.modal.hidden = false;
          document.documentElement.classList.add('nrev-open');
          this.querySelector('.nrev-form').hidden = false;
          this.querySelector('[data-nrev-done]').hidden = true;
          const first = this.modal.querySelector(FOCUSABLE);
          if (first) first.focus();
        }

        closeModal() {
          this.modal.hidden = true;
          document.documentElement.classList.remove('nrev-open');
          if (this.modalOpener) this.modalOpener.focus();
        }

        /* ---------- the form ---------- */

        buildRating() {
          const wrap = this.querySelector('[data-nrev-rate]');
          const word = this.querySelector('[data-nrev-rate-word]');
          let html = '';
          for (let n = 1; n <= 5; n += 1) {
            html +=
              '<button type="button" class="nrev-rate__btn" data-nrev-star="' + n +
              '" aria-label="' + n + ' star' + (n > 1 ? 's' : '') + '" aria-pressed="false">' + star(1) + '</button>';
          }
          wrap.insertAdjacentHTML('afterbegin', html);

          /* The five stars are drawn once and then only recoloured, by toggling the empty
             class on the square inside each one. Repainting used to rewrite each button's
             innerHTML, which is why the picker did nothing on a phone: a tap fires a mouse
             event before the click, that repaint replaced the very SVG the finger was on,
             and by the time the click arrived its target had been detached from the
             document — so closest() found no button and the handler gave up. On a mouse
             the repaint happens on hover, long before the click, which is why it only ever
             failed on touch. */
          const paint = (value) => {
            wrap.querySelectorAll('[data-nrev-star]').forEach((b) => {
              const n = Number(b.dataset.nrevStar);
              const box = b.querySelector('.nrev-star__box');
              if (box) box.classList.toggle('nrev-star__box--empty', n > value);
              b.setAttribute('aria-pressed', String(n === this.state.draftRating));
            });
            word.textContent = WORDS[value] || '';
          };

          wrap.addEventListener('click', (e) => {
            const b = e.target.closest('[data-nrev-star]');
            if (!b) return;
            this.state.draftRating = Number(b.dataset.nrevStar);
            paint(this.state.draftRating);
            this.checkForm();
          });

          wrap.addEventListener('mouseover', (e) => {
            const b = e.target.closest('[data-nrev-star]');
            if (b) paint(Number(b.dataset.nrevStar));
          });

          wrap.addEventListener('mouseleave', () => paint(this.state.draftRating));
          paint(0);
        }

        bindForm() {
          const form = this.querySelector('.nrev-form');
          const submit = this.querySelector('[data-nrev-submit]');
          const hint = this.querySelector('[data-nrev-hint]');

          /* In email mode there is nowhere to send a photo, so the field is not offered
             rather than accepted and dropped. */
          if (this.mode === 'email') {
            const photoField = this.querySelector('[data-nrev-photo-field]');
            if (photoField) photoField.hidden = true;
          }

          /* Endpoint mode with no endpoint means nothing to submit to. The button stays
             disabled and the hint says why, rather than showing a thank-you for a review
             that went nowhere. */
          if (this.mode === 'endpoint' && !this.endpoint) {
            hint.textContent =
              'Submissions are not connected yet. Add your reviews endpoint under "Write a review" in the theme editor to switch this on.';
          }

          form.addEventListener('input', () => this.checkForm());

          this.querySelector('[data-nrev-upload]').addEventListener('change', (e) => {
            const file = e.target.files && e.target.files[0];
            if (!file) return;
            const preview = this.querySelector('[data-nrev-preview]');
            this.querySelector('[data-nrev-preview-img]').src = URL.createObjectURL(file);
            preview.hidden = false;
          });

          this.querySelector('[data-nrev-remove]').addEventListener('click', () => {
            this.querySelector('[data-nrev-file]').value = '';
            this.querySelector('[data-nrev-preview]').hidden = true;
            this.querySelector('[data-nrev-preview-img]').src = '';
          });

          form.addEventListener('submit', (e) => {
            if (submit.disabled) {
              e.preventDefault();
              return;
            }

            /* Email mode does not touch the event. The browser posts the form itself, which
               is the only way Shopify's spam protection gets to run: it listens for this
               same submit event, fetches a captcha token and releases the post. Anything
               that submits from code instead — form.submit(), a background fetch, a hidden
               iframe — skips that listener and the store answers "Missing CAPTCHA token".
               The page therefore reloads, and restoreAfterPost puts the thank-you back. */
            if (this.mode === 'email') {
              const ratingField = this.querySelector('[data-nrev-rating-field]');
              if (ratingField) ratingField.value = this.state.draftRating + ' out of 5';
              try {
                sessionStorage.setItem(
                  POST_KEY,
                  String(form.elements['contact[name]'].value || '').split(' ')[0]
                );
              } catch (err) {
                /* Private browsing. The review still sends; only the thank-you is lost. */
              }
              hint.textContent = 'Sending your review...';
              return;
            }

            e.preventDefault();
            const payload = {
              rating: this.state.draftRating,
              title: form.elements['contact[Review title]'].value,
              body: form.elements['contact[body]'].value,
              name: form.elements['contact[name]'].value,
              email: form.elements['contact[email]'].value,
              product: this.dataset.scope || ''
            };

            submit.disabled = true;
            this.sendToEndpoint(payload)
              .then((res) => {
                if (!res.ok) throw new Error('HTTP ' + res.status);
                this.showDone(String(payload.name || '').split(' ')[0]);
              })
              .catch(() => {
                hint.textContent = 'That did not go through. Please try again in a moment.';
                submit.disabled = false;
              });
          });
        }

        /* Run on load, and the other half of an email-mode submission. Shopify answers an
           accepted contact form with a redirect back to the page that sent it, carrying
           ?contact_posted=true, and the {% form %} block marks that page with
           data-nrev-posted. Both of those plus this tab's own flag have to agree before a
           thank-you appears, so landing on someone else's posted URL shows nothing. */
        restoreAfterPost() {
          if (!this.querySelector('[data-nrev-posted]')) return;

          let name = null;
          try {
            name = sessionStorage.getItem(POST_KEY);
            sessionStorage.removeItem(POST_KEY);
          } catch (e) {
            return;
          }
          if (name === null) return;

          /* The query string has done its job. It should not survive a refresh, and it
             should not travel in a copied link. */
          try {
            const url = new URL(window.location.href);
            url.searchParams.delete('contact_posted');
            window.history.replaceState({}, '', url.pathname + url.search + url.hash);
          } catch (e) {
            /* Cosmetic. */
          }

          this.scrollIntoView({ block: 'start' });
          this.openModal(this.querySelector('[data-nrev-open]'));
          this.showDone(name);
        }

        sendToEndpoint(payload) {
          return fetch(this.endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });
        }

        checkForm() {
          const form = this.querySelector('.nrev-form');
          const submit = this.querySelector('[data-nrev-submit]');
          const need = ['contact[Review title]', 'contact[body]', 'contact[name]', 'contact[email]'];
          const filled = need.every((n) => String(form.elements[n].value || '').trim().length > 0);
          const email = /.+@.+\..+/.test(String(form.elements['contact[email]'].value || ''));
          const connected = this.mode === 'email' || !!this.endpoint;
          submit.disabled = !(connected && filled && email && this.state.draftRating > 0);
        }

        showDone(firstName) {
          this.querySelector('.nrev-form').hidden = true;
          const done = this.querySelector('[data-nrev-done]');
          this.querySelector('[data-nrev-done-title]').textContent =
            'Thank you' + (firstName ? ', ' + firstName : '');
          done.hidden = false;
          done.querySelector('button').focus();
        }

        disconnectedCallback() {
          document.removeEventListener('keydown', this.onKey);
          document.documentElement.classList.remove('nrev-open');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuance-wishlist"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nuance-wishlist')) {
    customElements.define(
      'nuance-wishlist',
      class extends HTMLElement {
        connectedCallback() {
          this.grid = this.querySelector('[data-grid]');
          this.empty = this.querySelector('[data-empty]');
          this.loading = this.querySelector('[data-loading]');
          this.root = this.dataset.root || '/';
          if (!this.root.endsWith('/')) this.root += '/';

          this.onChange = () => this.prune();
          document.addEventListener('nuance:wishlist-change', this.onChange);
          this.load();
        }

        disconnectedCallback() {
          document.removeEventListener('nuance:wishlist-change', this.onChange);
        }

        readList() {
          try {
            const list = JSON.parse(localStorage.getItem('nuance:wishlist') || '[]');
            return Array.isArray(list) ? list : [];
          } catch (e) {
            return [];
          }
        }

        saveList(list) {
          try {
            localStorage.setItem('nuance:wishlist', JSON.stringify(list));
          } catch (e) {}
          document.dispatchEvent(new CustomEvent('nuance:wishlist-change', { detail: { list } }));
        }

        async load() {
          const list = this.readList();
          if (!list.length) return this.finish();

          const results = await Promise.all(
            list.map(async (handle) => {
              try {
                const response = await fetch(this.root + 'products/' + encodeURIComponent(handle) + '?view=nuance-card');
                if (!response.ok) return { handle, html: null };
                return { handle, html: (await response.text()).trim() };
              } catch (e) {
                return { handle, html: '' };
              }
            })
          );

          const missing = results.filter((r) => r.html === null).map((r) => r.handle);
          if (missing.length) this.saveList(list.filter((h) => !missing.includes(h)));

          results
            .slice()
            .reverse()
            .forEach((r) => {
              if (!r.html) return;
              const li = document.createElement('li');
              li.className = 'nwish__item';
              li.dataset.handle = r.handle;
              li.innerHTML = r.html;
              this.grid.appendChild(li);
            });

          this.finish();
        }

        prune() {
          const list = this.readList();
          this.grid.querySelectorAll('.nwish__item').forEach((item) => {
            if (!list.includes(item.dataset.handle)) item.remove();
          });
          this.finish();
        }

        finish() {
          if (this.loading) this.loading.hidden = true;
          this.empty.hidden = this.grid.children.length > 0;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nuance-trust-slider')) {
    customElements.define(
      'nuance-trust-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          if (!this.track || !this.dots.length) return;

          this.dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
              this.track.scrollTo({ left: index * this.track.clientWidth, behavior: 'smooth' });
            });
          });

          this.onScroll = () => {
            const width = this.track.clientWidth || 1;
            const active = Math.round(this.track.scrollLeft / width);
            this.dots.forEach((dot, index) => {
              dot.classList.toggle('is-active', index === active);
              dot.setAttribute('aria-current', index === active ? 'true' : 'false');
            });
          };

          this.track.addEventListener('scroll', this.onScroll, { passive: true });
        }

        disconnectedCallback() {
          if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
